import * as React from "react"

import { cn } from "@/lib/utils"

/**
 * `requiredField`: 필수 입력 필드를 시각적으로 강조합니다 (은은한 강조 보더 + 배경).
 * 기본값 false 라서 기존 사용처에는 영향이 없습니다. `aria-invalid` 가 true 면
 * 강조 대신 빨간 보더(유효성 오류)가 우선 적용됩니다.
 */
function Input({
  className,
  type,
  requiredField = false,
  ...props
}: React.ComponentProps<"input"> & { requiredField?: boolean }) {
  return (
    <input data-imp="components/ui/input.tsx:17:5"
      type={type}
      data-slot="input"
      data-required-field={requiredField || undefined}
      className={cn(
        "file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
        "data-[required-field=true]:border-primary/40 data-[required-field=true]:bg-primary/[0.03] dark:data-[required-field=true]:bg-primary/10",
        "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
        className
      )}
      {...props}
    />
  )
}

export { Input }
